import React from 'react'
import { SnackBarStyle } from './styles'
import { Snackbar } from '../LazyComponents'

type SnackbarProps = {
  text: string
  color: 'red' | 'blue' | 'green'
  show: boolean
  onClose?: () => void
}

export const GeneralSnackbar: React.FC<SnackbarProps> = ({
  text,
  color,
  show,
  onClose,
}) => {
  const handleClose = (_event?: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return
    }
    onClose?.()
  }

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      open={show}
      onClose={handleClose}
      role="alert"
      aria-live="polite"
    >
      <SnackBarStyle color={color} role="status">
        <p>{text}</p>
      </SnackBarStyle>
    </Snackbar>
  )
}
